import { Avatar, Button, HStack, Icon, Stack, StackProps, Text, useColorModeValue, useMenuButton } from '@ecoinvent/ui';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

type Props = StackProps & { id: string; name?: string; email?: string; isLoading?: boolean; imageSrc?: string };

const UserMenuButton = ({ id, name, email, imageSrc, ...rest }: Props) => {
  const buttonProps = useMenuButton(rest);
  const isOpen = !!buttonProps['aria-expanded'];

  const bg = useColorModeValue('blackAlpha.50', 'whiteAlpha.50');
  const borderColor = useColorModeValue('transparent', 'whiteAlpha.200');
  return (
    <HStack
      {...buttonProps}
      as={Button}
      variant="ghost"
      colorScheme="black"
      aria-label="account of current user"
      aria-controls={id}
      aria-haspopup="true"
      w="full"
      display="flex"
      alignItems="center"
      justifyContent={'space-between'}
      rounded="lg"
      px="3"
      py="3"
      fontSize="sm"
      _hover={{ bg: 'blackAlpha.100' }}
      _active={{ bg: 'blackAlpha.200' }}
      bg={bg}
      height={'auto'}
      border={'1px solid'}
      borderColor={borderColor}
    >
      <HStack>
        <Avatar size="sm" name={name} src={imageSrc} />
        <Stack spacing={1} alignItems={'flex-start'}>
          <Text fontSize={'14px'} fontWeight="bold" isTruncated maxW={'140px'}>
            {name}
          </Text>
          <Text fontSize={'small'} fontWeight={'normal'} isTruncated maxW={'140px'}>
            {email}
          </Text>
        </Stack>
      </HStack>
      <Icon as={!isOpen ? BiChevronUp : BiChevronDown} />
    </HStack>
  );
};

export default UserMenuButton;
